import { AccountVendorDashboardView } from '@zola/svc-marketplace-ts-types';

import { AppThunk } from '~/reducers';
import ApiService from '~/util/apiService';
import { StandardLogFn } from '~/util/logger';

import {
  ReceivedVendorTeamAction,
  RECEIVED_VENDOR_TEAM,
  RequestingVendorTeamAction,
  REQUESTING_VENDOR_TEAM,
} from './types/vendorTeamActionTypes';

const requesting = (): RequestingVendorTeamAction => ({
  type: REQUESTING_VENDOR_TEAM,
});

const received = (response: AccountVendorDashboardView[]): ReceivedVendorTeamAction => ({
  type: RECEIVED_VENDOR_TEAM,
  payload: response,
});

export const fetchVendorTeam = (): AppThunk<Promise<void>> => {
  return (dispatch) => {
    dispatch(requesting);
    return ApiService.get('/web-marketplace-api/v1/account/vendors-dashboard')
      .then((data: AccountVendorDashboardView[]) => {
        if (data) {
          dispatch(received(data));
        }
      })
      .catch(StandardLogFn);
  };
};
